import { fetchGraphQL } from "@models/lib/fetch-graphql";
import { gql } from "apollo-boost";

export const SHOWCASE_BANNER_QUERY = gql`
  query {
    allShowcaseBanners {
      title
      titleColor
      description
      descriptionColor
      propductLink
      preOrderButton
      preOrderButtonColor
      color
      image {
        url
      }
      show
    }
  }
`;

export default class ShowcaseBannerApi {
  static async fetchShowcasesBanner() {
    return fetchGraphQL(SHOWCASE_BANNER_QUERY).then(
      (res) => res["allShowcaseBanners"] || []
    );
  }
}
